// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createHooksHooks = (client) => ({
    /**
     * `POST /hooks/payouts`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId HooksHooksPayoutsCreate
     * @source packages/modules/b2c-core/src/api/hooks/payouts/route.ts
     */
    createPayout: (body, query, headers) => client.fetch("/hooks/payouts", { method: "POST", body, query, headers }),
    /**
     * `POST /hooks/payment-call/bolna`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId HooksPaymentCallBolnaCreate
     * @source apps/backend/src/api/hooks/payment-call/bolna/route.ts
     */
    updatePaymentCallBolna: (body, query, headers) => client.fetch("/hooks/payment-call/bolna", { method: "POST", body, query, headers }),
});
//# sourceMappingURL=hooks.js.map